import React from 'react';
import { Controller } from 'react-hook-form';
import _get from 'lodash/get';
import Textarea from '../baseui/input/textarea';

interface ITextAreaInput {
	name: any;
	control: any;
	defaultValue: any;
	minHeight: any;
}

const TextAreaInput: React.FC<ITextAreaInput> = (props) => {
	const { name, control, defaultValue, minHeight } = props;

	return (
		<Controller
			render={({ field: { onChange, value } }) => {
				return (
					<Textarea
						{...props}
						value={value}
						onChange={onChange}
						overrides={{
							Input: {
								style: {
									minHeight: minHeight ?? '100px',
									resize: 'vertical',
									width: 'inherit'
								}
							},
							InputContainer: {
								style: {
									maxWidth: '100%',
									width: 'inherit'
								}
							}
						}}
					/>
				);
			}}
			control={control}
			name={name}
			defaultValue={defaultValue && _get(defaultValue, ['field', ...defaultValue.path])}
		/>
	);
};

export default TextAreaInput;
